<app-stages [stages]='stages' currentStage='Wnioskodawca'>
</app-stages>
<br>
@if (!pending() && !loading()) {
  <form novalidate autocomplete='off' [formGroup]='proxyPersonForm'>
    <br>
    <div class='row'>
      <div class='col-12'>
        <div class='form-group' *ngIf='"isFiledByProxy" as controlName'>
          <div class='custom-checkbox custom-inline'
               [ngClass]='{ "is-invalid": proxyPersonForm.showError(controlName) }'>
            <input
              (change)="proxyPersonForm.isFiledByProxyChange()"
              [formControlName]='controlName'
              type='checkbox'
              [id]='controlName'
              [name]='controlName'>
            <label [for]='controlName'>
              Składam wniosek przez pełnomocnika
            </label>
          </div>
          <app-validation-errors [control]='proxyPersonForm.isFiledByProxy'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    @if (proxyPersonForm.isFiledByProxy.value) {
      <br>
      <app-proxy-form [form]='proxyPersonForm'>
      </app-proxy-form>
    }
  </form>
  <br>
  @if (applicants().length) {
    <app-accordion-group>
      @for (applicant of applicants(); track $index) {
        <app-accordion-item
          [name]='$index + 1 + ". " + (applicant?.applicant | entityLabel)'>
          <app-applicant-item-preview *ngIf='applicant?.applicant as item' [applicant]='item'>
          </app-applicant-item-preview>
          <span slot='action'>
            <button
              (click)='onEditApplicant($event, $index)'
              class='btn btn-secondary icon-btn'
              title='Edytuj'
              [disabled]='showItemForm'>
              <i class='fa fa-pencil-alt'></i>
            </button>
            &nbsp;
            <button [disabled]='showItemForm' type='button' class='btn btn-red-secondary icon-btn' title='Usuń z listy'
                    (click)='onRemove($index, $event)'>
              <i class='fa fa-trash-alt'></i>
            </button>
          </span>
        </app-accordion-item>
      }
    </app-accordion-group>
  } @else {
    <app-alert alertTitle="Brak dodanych wnioskodawców!" [closable]="false"></app-alert>
  }
  @if (!showItemForm) {
    <br>
    <div class='d-flex justify-content-end'>
      <button type='button' class='btn btn-primary' (click)='onAdd()'>
        {{ applicants().length ? "Dodaj dane kolejnej osoby" : "Dodaj dane wnioskodawcy" }}
      </button>
    </div>
  }
  @if (showItemForm) {
    <div class='gov-card'>
      <div class='gov-card__header'>
        Dodanie wnioskodawcy
      </div>
      <div class='gov-card__body'>
        <app-tab-view #tabViewComponent [centered]='true'>
          @for (entityType of entityTypes(); track $index) {
            @if (entityType.code === "OSOBA_FIZYCZNA") {
              <app-tab-panel #naturalPersonTab [name]='entityType.name' [selected]='$index === 0'>
                <app-natural-person-form
                  *ngIf='naturalPersonTab.selected'
                  [autoFillButtons]='!proxyPersonForm.isFiledByProxy.value'
                  [edit]='currentIndex() !== undefined'
                  [form]='applicantForm'
                  (onCancel)='this.showItemForm = false'
                  (onSubmit)='onUpdateApplicants($event)'>
                </app-natural-person-form>
              </app-tab-panel>
            }
            @if (entityType.code === "OSOBA_FIZYCZNA_DG") {
              <app-tab-panel #institutionTab [name]='entityType.name' [selected]='$index === 0'>
                <app-institution-form
                  *ngIf='institutionTab.selected'
                  [edit]='currentIndex() !== undefined'
                  [form]='applicantForm'
                  (onCancel)='this.showItemForm = false'
                  (onSubmit)='onUpdateApplicants($event)'>
                </app-institution-form>
              </app-tab-panel>
            }
            @if (entityType.code === 'OSOBA_PRAWNA') {
              <app-tab-panel #companyTab [name]='entityType.name' [selected]='$index === 0'>
                <app-company-form
                  *ngIf='companyTab.selected'
                  [edit]='currentIndex() !== undefined'
                  [form]='applicantForm'
                  (onCancel)='this.showItemForm = false'
                  (onSubmit)='onUpdateApplicants($event)'>
                </app-company-form>
              </app-tab-panel>
            }
          }
        </app-tab-view>
      </div>
    </div>
    <br>
  }
  <div class='application-actions'>
    <button type='button' class='btn btn-secondary' (click)='onCancel()'>
      <span>
        Wstecz
      </span>
    </button>
    <button
      [disabled]='showItemForm || !serviceType()'
      type='button'
      class='btn btn-primary'
      (click)='submitAndGoNext()'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
